import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import languageEN from "./locales/en-US/translations.json";
import languageAR from "./locales/ar-SA/translations.json";
import languageES from "./locales/es-ES/translations.json";
import languagePT from "./locales/pt-PT/translations.json";
import languageCN from "./locales/zh-CN/translations.json";
import languageTW from "./locales/zh-TW/translations.json";
import languageHI from "./locales/hi-IN/translations.json";
import languageTA from "./locales/ta-IN/translations.json";
import languageTE from "./locales/te-IN/translations.json";
import languageML from "./locales/ml-IN/translations.json";

export const supportedLngs = ["ar", "zh", "zh-Hant", "en", "pt", "es", "hi", "ta", "te", "ml"];

const resources = {
  en: {
    translations: languageEN || {}
  },
  ar: {
    translations: languageAR || {}
  },
  es: {
    translations: languageES || {}
  },
  pt: {
    translations: languagePT || {}
  },
  zh: {
    translations: languageCN || {}
  },
  "zh-Hant": {
    translations: languageTW || {}
  },
  hi: {
    translations: languageHI || {}
  },
  ta: {
    translations: languageTA || {}
  },
  te: {
    translations: languageTE || {}
  },
  ml: {
    translations: languageML || {}
  }
};

// 基础配置
const baseConfig = {
  supportedLngs,
  fallbackLng: "en",
  debug: false,
  ns: ["translations"],
  defaultNS: "translations",
  resources,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  interpolation: {
    escapeValue: false,
    formatSeparator: ",",
    // 启用 plural 和 context 支持
    prefix: "{{",
    suffix: "}}",
    skipOnVariables: false
  },
  react: {
    useSuspense: true
  }
};

// 初始化 i18n（只执行一次）
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    ...baseConfig,
    lng: "en", // 默认语言
    detection: {
      order: ["cookie", "htmlTag", "navigator"],
      lookupCookie: "i18nextLng",
      caches: ["cookie"],
      cookieOptions: {
        path: "/",
        sameSite: "strict" as const,
        maxAge: 365 * 24 * 60 * 60 * 1000 // 1年
      }
    }
  });

export default i18n;
